import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { index, destroy } from '../../../apis'
import { showAlert, removeBandmate } from '../../../actions'
import makeStyles from '@mui/styles/makeStyles'
import { useIsMounted } from '../../../hooks'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemText from '@mui/material/ListItemText'
import ListItemAvatar from '@mui/material/ListItemAvatar'
import Avatar from '@mui/material/Avatar'
import Typography from '@mui/material/Typography'
import { CloseButton, FormDeleteButton, ThreeDotProgress } from '../../generics'


const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    padding: 30
  },
  title: {
    fontSize: '1.7rem',
    marginBottom: 24,
    marginTop: 24
  },
  bold: {
    fontWeight: 800,
  },
  avatar: {
    width: theme.spacing(6),
    height: theme.spacing(6),
    marginRight: 15
  },
  item: {
    minWidth: 320,
    padding: 12,
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    '&:hover': {
      backgroundColor: '#dfdfdf'
    }
  },
  button: {
    marginTop: 0,
    marginLeft: 24,
    minWidth: 74,
    width: 74,
    height: 36,
    fontSize: '0.8rem'
  },
  ownerText: {
    width: 74,
    margin: '0 auto'
  }
}))

const RemoveBandMembers = props => {
  const classes = useStyles()
  const isMounted = useIsMounted()
  const [permissions, setPermissions] = useState('fetching')
  const { 
    bandId,
    members, 
    handleClose, 
    showAlert, 
    removeBandmate 
  } = props


  useEffect(() => {
    index('bands/' + bandId + '/bandmates/permissions')
      .then(response => {
        if (isMounted.current) setPermissions(response.data)
      })
      .catch(error => {
        if (isMounted.current) setPermissions({})
      })
  }, [bandId, isMounted])


  const handleClick = permission => () => {
    if (permission === 'owner') showAlert('An owner cannot be removed', 'error')
  }


  const removeBandMember = artist => () => {
    destroy('bands/' + bandId + '/bandmates/remove', { artist_id: artist.id })
      .then(response => {
        if (response && response.data) {
          removeBandmate(bandId, artist.id)
          showAlert(artist.attributes.name + ' was removed from the band', 'success')
        }
      })
      .catch(error => {
        showAlert('Something went wrong', 'error')
      })
  }


  return (
    <div className={ classes.root }>
      <CloseButton onClick={ handleClose } />

      <Typography className={ classes.title }>
        <span className={ classes.bold }>Remove</span> Members
      </Typography>

      { permissions === 'fetching' 
        ? <ThreeDotProgress />
        : <List>
          { Object.values(members).map(artist => {
              const { name, image, imageDerivatives } = artist.attributes
              const imageURL = imageDerivatives.small || image
              const permission = permissions[artist.id]
              
              return (
                <ListItem
                  disabled={ permission === 'owner' }
                  key={ artist.id } 
                  className={ classes.item }
                  onClick={ handleClick(permission, artist.id) }>

                  <ListItemAvatar>
                    <Avatar 
                      className={ classes.avatar }
                      alt={ name } 
                      src={ imageURL } />
                  </ListItemAvatar>

                  <ListItemText 
                    primary={ name } 
                    primaryTypographyProps={{ noWrap: true }} />
                    { permission === 'owner' 
                      ? <div className={ classes.ownerText }>
                          <Typography align='center'>Owner</Typography>
                        </div>
                      : <FormDeleteButton
                          className={ classes.button }
                          onClick={ removeBandMember(artist) }>
                          REMOVE
                        </FormDeleteButton>
                    }
                </ListItem>
              )
            })
          }
          </List>
      }
    </div>
  )
}


export default connect(null,  { showAlert, removeBandmate })(RemoveBandMembers)

